import { useState, type FormEvent } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { useAdminAuth } from "../AuthContext.js";
import styles from "../admin.module.css";

export function Login() {
  const { status, login } = useAdminAuth();
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [submitting, setSubmitting] = useState(false);

  if (status === "authenticated") return <Navigate to="/admin" replace />;

  async function handleSubmit(e: FormEvent) {
    e.preventDefault();
    setSubmitting(true);
    setError(null);
    const result = await login(password);
    setSubmitting(false);
    if (result.ok) {
      navigate("/admin");
      return;
    }
    if (result.error === "TOO_MANY_ATTEMPTS") {
      setError(
        `Zu viele Fehlversuche. Bitte in ${result.retryAfterSeconds ?? 30} Sekunden erneut versuchen.`,
      );
    } else {
      setError("Falsches Passwort.");
    }
  }

  return (
    <div className={styles.loginShell}>
      <form className={styles.loginCard} onSubmit={handleSubmit}>
        <h1 className={styles.loginTitle}>Roughly Admin</h1>
        {error && <div className={styles.errorBox}>{error}</div>}
        <div className={styles.formRow}>
          <label htmlFor="admin-password">Passwort</label>
          <input
            id="admin-password"
            type="password"
            className={styles.input}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            autoFocus
            required
          />
        </div>
        <button type="submit" className={`${styles.button} ${styles.fullWidth}`} disabled={submitting}>
          Anmelden
        </button>
      </form>
    </div>
  );
}
